import Vue from 'vue';
import App from './App.vue';
import './registerServiceWorker';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';
import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/functions';

// import moment from 'moment';

import filters from '@/filters';
import loadGoogleMapsApi from './service/google';

import VueGapi from 'vue-gapi';

import VueTour from 'vue-tour';
import 'vue-tour/dist/vue-tour.css';

import PerfectScrollbar from 'vue2-perfect-scrollbar';
import 'vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css';

import { StripePlugin } from '@vue-stripe/vue-stripe';

import posthog from 'posthog-js';

import HelloSign from 'hellosign-embedded';
import DatetimePicker from 'vuetify-datetime-picker';
import interceptors from './service/interceptors';

const stripeOptions = {
  pk: process.env.VUE_APP_STRIPE_PUBLISHABLE_KEY,
  testMode: process.env.NODE_ENV !== 'production',
  stripeAccount: process.env.VUE_APP_STRIPE_ACCOUNT,
  apiVersion: '2020-03-02',
  locale: 'en_US',
};

const hellosign = new HelloSign({
  clientId: process.env.VUE_APP_HELLOSIGN_CLIENT_ID,
});

if (window.location.hostname === 'localhost') {
  process.env.FIRESTORE_EMULATOR_HOST = 'localhost:8080';
}

const firebaseConfig = {
  apiKey: process.env.VUE_APP_GOOGLE_API_KEY,
  authDomain: process.env.VUE_APP_AUTH_DOMAIN,
  databaseURL: process.env.VUE_APP_DATABASE_URL,
  projectId: process.env.VUE_APP_PROJECT_ID,
  storageBucket: process.env.VUE_APP_STORAGE_BUCKET,
  appId: process.env.VUE_APP_APP_ID,
};

Vue.config.productionTip = false;

// register plugins
Vue.use(StripePlugin, stripeOptions);

const initializeChatbot = () => {
  const src = 'https://www.chatbase.co/embed.min.js';
  const chatbotId = 'i0RWw2HNO0QFoNQnIOouu';
  const domain = 'www.chatbase.co';

  const script = document.createElement('script');
  script.src = src;
  script.defer = true;
  script.setAttribute('chatbotId', chatbotId);
  script.setAttribute('domain', domain);
  document.head.appendChild(script);

  window.embeddedChatbotConfig = {
    chatbotId: chatbotId,
    domain: domain,
  };
};

initializeChatbot();

Vue.use(filters);
Vue.use(VueTour);
Vue.use(PerfectScrollbar);

Vue.use(DatetimePicker);

Vue.use(VueGapi, {
  apiKey: process.env.VUE_APP_GOOGLE_API_KEY,
  clientId:
    '442560778465-o4cdpn8fhv5tc0hk13thes2na3h6ba82.apps.googleusercontent.com',
  discoveryDocs: ['https://sheets.googleapis.com/$discovery/rest?version=v4'],
  scope: 'https://www.googleapis.com/auth/spreadsheets',
});

// initialize firebase
firebase.initializeApp(firebaseConfig);
interceptors();

// use emulators on local
if (window.location.hostname === 'localhost') {
  firebase.firestore().useEmulator('localhost', 8080);
  firebase.auth().useEmulator('http://localhost:9099/');
}

firebase.firestore();

// set auth persistence
firebase.auth().setPersistence(firebase.auth.Auth.Persistence.LOCAL);

// initialize snapshots
Vue.prototype.$snapshots = {};

// initialize hellosign
Vue.prototype.$hellosign = hellosign;

loadGoogleMapsApi(firebaseConfig.apiKey).then(
  (google) => (Vue.prototype.google = google)
);

const unsubscribe = firebase.auth().onAuthStateChanged((firebaseUser) => {
  if (!window.VueInstance) {
    window.VueInstance = new Vue({
      el: '#app',
      router,
      store,
      vuetify,
      render: (h) => h(App),
      async created() {
        if (firebaseUser) {
          this.$store.dispatch('auth/auth_action', firebaseUser);

          const user = await (
            await firebase
              .firestore()
              .collection('users')
              .doc(firebaseUser.uid)
              .get()
          ).data();

          if (user) {
            if (process.env.NODE_ENV === 'production') {
              posthog.init('phc_JX3Xh5Bz6xydEkqDfdgOuAQnh1s6bhQUOYe4MBDRaLp', {
                api_host: 'https://app.posthog.com',
                loaded: (posthog) => {
                  posthog.identify(firebaseUser.uid, { email: user.email });
                },
              });
            }

            const org = await (
              await firebase
                .firestore()
                .collection('organizations')
                .doc(user.orgId)
                .get()
            ).data();

            if (org) {
              this.$store.dispatch('auth/customer_action', org);
            }

            this.$store.dispatch('auth/get_organization', user.orgId);
            const path = router.currentRoute.name;
            if (
              org?.org_type === 'exporter' &&
              (path === 'Containers' ||
                path === 'Dashboard' ||
                path === 'Turns')
            ) {
              router.push('/bookings').catch(() => {});
            } else if (org?.org_type !== 'exporter' && path === 'Bookings') {
              router.push('/marketplace?page=exportloads').catch(() => {});
            }
            // unsubscribe after first authentication
            unsubscribe();
          }
        }
      },
    }).$mount('#app');
  }
});
